import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonCloudStudioModule, ENVIRONMENT } from 'common-cloudstudio';
import { MapService } from '../shared/services/map.service';
import { mapRoutes } from './map.routes';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AlarmsMapComponent } from './alarms-map/alarms-map.component';
import { CustomMapComponent } from './custom-map/custom-map.component';
import { GoogleMapsModule } from '@angular/google-maps';


declare var environment;

export function environmentFactory(): any {
  return environment;
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    CommonCloudStudioModule,
    mapRoutes,
    TooltipModule.forRoot(),
    GoogleMapsModule,
  ],
  declarations: [AlarmsMapComponent, CustomMapComponent],
  exports: [AlarmsMapComponent, CustomMapComponent],
  providers: [MapService, { provide: ENVIRONMENT, useFactory: environmentFactory },]
})
export class MapsModule { }
